import React from 'react';
import { CloudSiteRegExp } from '@css-xp/ppc-constants';
export const useValidateCloudSite = (): {
  checkSiteUrl: (site: string) => boolean;
  isSiteValid: boolean | undefined;
} => {
  const [isSiteValid, setIsSiteValid] = React.useState<boolean | undefined>();
  const checkSiteUrl = (site: string) => {
    const patternOutput = CloudSiteRegExp.test(site);
    setIsSiteValid(patternOutput);
    return patternOutput;
  };

  return {
    checkSiteUrl,
    isSiteValid,
  };
};
